import Dashboard from "../Components/DashBoard/Dashboard";

const PHARMACY_ROUTES = {
  LOGIN: "/",
  DASHBOARD: "/dashBoard",
  CHE_ORDERS: "/cheOrders",
  B2C_ORDERS: "/b2cOrders",
  B2B_ORDERS: "/b2bOrders",
  EYEWEAR_ORDERS: "/eyewearOrders",
  ENQUIRY_REPORT: "/enquiry",
  ORDER_REPORT: "/orderReport",
  B2B_ORDERSREPORT: "/b2bOrderReport",
  B2C_ORDERSREPORT: "/b2cOrderReport",
  EYEWEAR_ORDERSREPORT: "/eyewearOrderReport",
  CHE_CONSIGNMENT_REPORT: "/consignment/che",
  B2B_CONSIGNMENT_REPORT: "/consignment/b2b",
  B2C_CONSIGNMENT_REPORT: "/consignment/b2c",
  PROFILE: "/profile",
  // Master › Medicine requests — raise/track (requester) + approve/reject (master data)
  MEDICINE_REQUESTS: "/master/medicine-requests",
  MEDICINE_REQUEST_APPROVALS: "/master/medicine-requests/approvals",
  // Master › Racks — storage-location master + the medicine → home-shelf map
  RACKS: "/master/racks",
  B2BPROFILE: "/b2bProfile/:id",
  B2B_KYCREPORT: "/b2bKycReport",
  GRN_TEMPLATE: "/grnTemplate",
  // Supply
  INVENTORY: "/inventory",
  PURCHASE_ORDERS: "/purchaseOrders",
  SUPPLIERS: "/suppliers", // Purchase › Suppliers (list / add / edit)
  GRN_INWARD: "/grn", // GRN receive — reached from a PO's "Receive · create GRN" (not in nav)
  PURCHASE_RETURN: "/purchase-returns", // Purchase › Purchase Return (debit note)
  PURCHASE_INVOICES: "/purchase-invoices", // Purchase › Purchase Invoice (Saveo orders + invoices)
  ALLOCATION_BILLING: "/allocationBilling", // Sales › Online Orders
  SALES_BILL_ENTRY: "/salesBillEntry", // Sales › Bill Entry (counter sale)
  // PACK_SHIP: "/packShip", // disabled for now
  INVOICES: "/invoices", // Sales › Bill History
  SALES_RETURN: "/sales-returns", // Sales › Sales Return (credit note)
  DOCTORS: "/doctors", // Sales › Doctors (prescribing-doctor master)
  // Supply › Reports (hubs)
  REPORTS_OVERVIEW: "/reports/overview", // store dashboard: stock value + daily trade
  STOCK_REPORT: "/reports/stock",
  SALES_REPORT: "/reports/sales",
  PURCHASE_REPORT: "/reports/purchase",
  // Stock sub-reports
  STOCK_REPORT_BATCHWISE: "/reports/stock/batchwise",
  STOCK_REPORT_EXPIRY: "/reports/stock/expiry",
  STOCK_REPORT_LOW: "/reports/stock/low",
  STOCK_REPORT_OUT_OF_STUCK: "/reports/stock/out-of-stuck",
  STOCK_REPORT_SNAPSHOT: "/reports/stock/snapshot",
  // Sales sub-reports
  SALES_REPORT_DATEWISE: "/reports/sales/datewise",
  SALES_REPORT_REGISTER: "/reports/sales/register",
  SALES_REPORT_CHANNEL: "/reports/sales/channel",
  SALES_REPORT_OUTSTANDING: "/reports/sales/outstanding",
  // Purchase sub-reports
  PURCHASE_REPORT_GRN_DATEWISE: "/reports/purchase/grn-datewise",
  PURCHASE_REPORT_REGISTER: "/reports/purchase/register",
  PURCHASE_REPORT_SUPPLIER: "/reports/purchase/supplier",
  PURCHASE_REPORT_ORDERS: "/reports/purchase/orders",
};
export { PHARMACY_ROUTES };
